import React from "react";
import "./style.scss";
import { CircularProgress } from "@mui/material";
import Localized from "../../Localized";

const SubscriptionPaymentItem = ({ item, isLoading=false, onClick }) => {
    return (
        <div className="subscription-payment-item" onClick={() => onClick(item)}>
            {isLoading ? (
                <CircularProgress size="15px" thickness={6} style={{ color: 'white' }} />
            ) : (
                <>
                    <span className="subscription-payment-item_title">
                        {item.title} {item.first_name && `- ${item.first_name}`}
                    </span>
                    {
                        item.last_payment ? (
                            <span className={`subscription-payment-item_info ${item.last_payment.status == 'success' ? "success" : "warning"}`}>
                                {item.last_payment.amount} {item.last_payment.currency}{" "}
                                {Localized[item.last_payment.status] || item.last_payment.status}
                            </span>
                        ) : (
                            <span className="subscription-payment-item_info warning">
                                {item.price.amount} {item.price.currency}{" "}
                                ожидается
                            </span>
                        )
                    }
                   
                    <span className="subscription-payment-item_date">
                        {new Date(item.last_payment ? item.updated_at : item.billing_information.renew_at).toLocaleString('ru-RU', {
                            day: '2-digit',
                            month: 'short',
                            hour: '2-digit',
                            minute: '2-digit'
                        })}
                    </span>
                </>
            )}
        </div>
    );
};

export default SubscriptionPaymentItem;
